import { ISelectedKey } from "../../SharedComponents/Interfaces/CustomContact.interfaces";

export const NO_DATA_MESSAGES: Record<ISelectedKey["selectedKey"], string> = {
  cxeContacts: "No CxE Contacts Found",
  manualContacts: "No Manual Contacts Found",
  automatedContacts: "No Automated Contacts Found",
  partnerContacts: "No Partner Contacts Found",
  generalContacts: "No Partner General Contacts Found.",
  csamContacts: "No Account Contacts Found"
};

export const GET_API_NAMES: Record<ISelectedKey["selectedKey"], string> = {
  cxeContacts: "useGetCustomerCxEContactListQuery",
  manualContacts: "useGetCustomerManualContactListQuery",
  automatedContacts: "useGetCustomerContactListQuery",
  partnerContacts: "useGetPartnerContactListQuery",
  generalContacts: "useGetPartnerContactListQuery",
  csamContacts: "useGetCSAMContactListQuery"
};